// extracted by mini-css-extract-plugin
module.exports = {"studentsText":"styles_studentsText__1yYiw"};